// bao migrate skip 
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import BaoSearchDialog from "./../../factories/bao-search-dialog";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
import TabController from "./../../factories/tab-controller";
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/log";
function ConfigurationItemSubprojectViewModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.TargetHoursHtml = ko.observable();
    self.TargetSumHtml = ko.observable();
    self.SubprojectTabCollection = ko.observableArray([]);
    self.SubprojectTabPageIndex = ko.observable(0);
    self.SubprojectTabPageIndex.subscribe(function () {
        self.RefreshSubprojectGrid();
    });
    self.SubprojectTabPageSize = ko.observable(25);
    self.SubprojectTabTotalRows = ko.observable(0);
    self.SubprojectTabSorting = ko.observableArray();
    self.SubprojectTabSorting.subscribe(function () {
        self.RefreshSubprojectTabGrid();
    });
    self.SelectedSubprojectTabRow = ko.observable({});
    self.SelectedSubprojectTabRow.subscribe(function (value) {
        self.ToggleSubprojectTabToolbarButtons();
        if (value != null) {
            self.SelectedSubprojectResourceTabRow(null);
            self.SelectedSubprojectQualificationTabRow(null);
        }
    });
    self.SelectedSubprojectQualificationTabRow = ko.observable({});
    self.SelectedSubprojectQualificationTabRow.subscribe(function (value) {
        self.ToggleSubprojectTabToolbarButtons();
        if (value != null) {
            self.SelectedSubprojectTabRow(null);
            self.SelectedSubprojectResourceTabRow(null);
        }
    });
    self.SelectedSubprojectResourceTabRow = ko.observable({});
    self.SelectedSubprojectResourceTabRow.subscribe(function (value) {
        self.ToggleSubprojectTabToolbarButtons();
        if (value != null) {
            self.SelectedSubprojectTabRow(null);
            self.SelectedSubprojectQualificationTabRow(null);
        }
    });
    self.SubprojectTabToolbarButtons = ko.observableArray();
    self.SubprojectTabToolbarButtons.subscribe(function () {
        self.ToggleSubprojectTabToolbarButtons();
    });
    self.ToggleSubprojectTabToolbarButtons = function () {
        self.ToggleSubprojectTabToolbarButtonsRec(self.SubprojectTabToolbarButtons());
    };
    self.ToggleSubprojectTabToolbarButtonsRec = function (buttons) {
        ko.utils.arrayForEach(buttons, function (button: any) {
            if (button.ActionKey() == "ConfigurationItemSubprojectTabDelete") {
                button.Enabled(self.SelectedSubprojectTabRow() != null || self.SelectedSubprojectQualificationTabRow() != null || self.SelectedSubprojectResourceTabRow() != null);
            }
            if (button.ActionKey() == "ConfigurationItemSubprojectTabEdit") {
                button.Enabled(self.SelectedSubprojectTabRow() != null || self.SelectedSubprojectQualificationTabRow() != null);
            }
            if (button.ActionKey() == "SubprojectTabAddQualification") {
                button.Enabled(self.SelectedSubprojectTabRow() != null || self.SelectedSubprojectQualificationTabRow() != null || self.SelectedSubprojectResourceTabRow() != null);
            }
            if (button.ActionKey() == "SubprojectTabAddResource") {
                button.Enabled(self.SelectedSubprojectQualificationTabRow() != null || self.SelectedSubprojectResourceTabRow() != null);
            }
            if (button.Items() != null && button.Items().length > 0) {
                self.ToggleSubprojectTabToolbarButtonsRec(button.Items());
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageSubprojectTab = Bao.Session.GetMessage("msgDeleteSubProject");
    var _deleteMessageQualificationTab = Bao.Session.GetMessage("msgDeleteSubProjectQualification");
    var _deleteMessageResourceTab = Bao.Session.GetMessage("msgDeleteSubProjectResource");
    self.QualificationId = ko.observable();
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemSubprojectTabNew":
                self.ShowSubprojectDialog(self.ConfigurationItem.ConfigurationItemId(), null);
                break;
            case "SubprojectTabAddQualification":
                if (self.SelectedSubprojectTabRow() != null) {
                    self.ShowSubprojectQualificationDialog(self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectTabRow().ConfigurationItemId(), null);
                }
                if (self.SelectedSubprojectQualificationTabRow() != null) {
                    self.ShowSubprojectQualificationDialog(self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectQualificationTabRow().ConfigurationItemId(), null);
                }
                if (self.SelectedSubprojectResourceTabRow() != null) {
                    self.ShowSubprojectQualificationDialog(self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectResourceTabRow().ConfigurationItemId(), null);
                }
                break;
            case "SubprojectTabAddResource":
                if (self.SelectedSubprojectQualificationTabRow() != null) {
                    self.ShowSubprojectResourceDialog(self.SelectedSubprojectQualificationTabRow().QualificationId(), self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectQualificationTabRow().ConfigurationItemId(), self.SelectedSubprojectQualificationTabRow().ConfigurationItem250QualificationId(), null);
                }
                if (self.SelectedSubprojectResourceTabRow() != null) {
                    self.ShowSubprojectQualificationDialog(self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectResourceTabRow().ConfigurationItemId(), null);
                }
                break;
            case "ConfigurationItemSubprojectTabEdit":
                if (self.SelectedSubprojectTabRow() != null) {
                    self.EditSubProject();
                }
                else if (self.SelectedSubprojectQualificationTabRow() != null) {
                    self.EditQualification();
                }
                else if (self.SelectedSubprojectResourceTabRow() != null) {
                    self.EditResource();
                }
                break;
            case "ConfigurationItemSubprojectTabDelete":
                if (self.SelectedSubprojectTabRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageSubprojectTab, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteSubproject(self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectTabRow().ConfigurationItemId());
                        }
                    });
                }
                else if (self.SelectedSubprojectQualificationTabRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageQualificationTab, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteQualification(self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectQualificationTabRow().ConfigurationItemId(), self.SelectedSubprojectQualificationTabRow().ConfigurationItem250QualificationId());
                        }
                    });
                }
                else if (self.SelectedSubprojectResourceTabRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageResourceTab, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteResource(self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectResourceTabRow().ConfigurationItemId, self.SelectedSubprojectResourceTabRow().ConfigurationItem250QualificationId(), self.SelectedSubprojectResourceTabRow().ConfigurationItem250ResourceId());
                        }
                    });
                }
                break;
        }
    };
    self.ShowSubprojectDialog = function (projectId, subProjectId) {
        tabPage.IsLoading(true);
        window.baorequire(["ViewModels/Dialogs/SubProjectDialog"], function (subProjectDialog) {
            var dialogVM = new subProjectDialog(self.ConfigurationItem.SessionTabId(), projectId, subProjectId, self.ConfigurationItem.IndicatorId());
            tabPage.IsLoading(false);
            dialogVM.Open();
            dialogVM.DialogResult.subscribe(function (result) {
                if (result == true) {
                    parent.TabPage.DirtyFlag(true);
                    self.RefreshSubprojectTabGrid();
                }
            });
        });
    };
    self.EditSubProject = function () {
        if (self.SelectedSubprojectTabRow() != null) {
            self.ShowSubprojectDialog(self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectTabRow().ConfigurationItemId());
        }
    };
    self.DeleteSubproject = function (parentConfigurationItemId, configurationItemId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/DeleteConfigurationItemSubproject", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            parentConfigurationItemId: parentConfigurationItemId,
            configurationItemId: configurationItemId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshSubprojectTabGrid();
        });
    };
    self.DeleteQualification = function (projectId, subProjectId, configurationItem250QualificationId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/RemoveConfigurationItemSubprojectQualification", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            parentConfigurationItemId: projectId,
            configurationItemId: subProjectId,
            configurationItem250QualificationId: configurationItem250QualificationId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshSubprojectTabGrid();
        });
    };
    self.EditQualification = function () {
        if (self.SelectedSubprojectQualificationTabRow() != null) {
            self.ShowSubprojectQualificationDialog(self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectQualificationTabRow().ConfigurationItemId(), self.SelectedSubprojectQualificationTabRow().ConfigurationItem250QualificationId());
        }
    };
    self.ShowSubprojectQualificationDialog = function (projectId, subProjectId, configurationItem250QualificationId) {
        tabPage.IsLoading(true);
        window.baorequire(["ViewModels/Dialogs/SubProjectQualificationDialog"], function (subProjectQualificationDialog) {
            var customerId = null;
            if (self.ConfigurationItem.ConfigurationItemTypeCategoryKey() == "Customer") {
                customerId = self.ConfigurationItem.ConfigurationItemId();
            }
            else {
                customerId = self.ConfigurationItem.CustomerId();
            }
            var dialogVM = new subProjectQualificationDialog(self.ConfigurationItem.SessionTabId(), customerId, projectId, subProjectId, configurationItem250QualificationId);
            tabPage.IsLoading(false);
            dialogVM.Open();
            dialogVM.DialogResult.subscribe(function (result) {
                if (result == true) {
                    parent.TabPage.DirtyFlag(true);
                    self.RefreshSubprojectTabGrid();
                }
            });
        });
    };
    self.DeleteResource = function (parentConfigurationItemId, configurationItemId, configurationItem250QualificationId, configurationItem250ResourceId) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/RemoveConfigurationItemSubprojectResource", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            parentConfigurationItemId: parentConfigurationItemId,
            configurationItemId: ko.unwrap(configurationItemId),
            configurationItem250QualificationId: configurationItem250QualificationId,
            configurationItem250ResourceId: configurationItem250ResourceId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshSubprojectTabGrid();
        });
    };
    self.EditResource = function () {
        if (self.SelectedSubprojectResourceTabRow() != null) {
            self.ShowSubprojectResourceDialog(self.SelectedSubprojectResourceTabRow().QualificationId(), self.ConfigurationItem.ConfigurationItemId(), self.SelectedSubprojectResourceTabRow().ConfigurationItemId(), self.SelectedSubprojectResourceTabRow().ConfigurationItem250QualificationId(), self.SelectedSubprojectResourceTabRow().ConfigurationItem250ResourceId());
        }
    };
    self.ShowSubprojectResourceDialog = function (qualificationId, projectId, subProjectId, configurationItem250QualificationId, configurationItem250ResourceId) {
        window.baorequire(["ViewModels/Dialogs/SubProjectResourceDialog"], function (subProjectResourceDialog) {
            var customerId = null;
            if (self.ConfigurationItem.ConfigurationItemTypeCategoryKey() == "Customer") {
                customerId = self.ConfigurationItem.ConfigurationItemId();
            }
            else {
                customerId = self.ConfigurationItem.CustomerId();
            }
            var dialogVM = new subProjectResourceDialog(self.ConfigurationItem.SessionTabId(), customerId, qualificationId, projectId, subProjectId, configurationItem250QualificationId, configurationItem250ResourceId);
            dialogVM.Open();
            dialogVM.DialogResult.subscribe(function (result) {
                if (result == true) {
                    parent.TabPage.DirtyFlag(true);
                    self.RefreshSubprojectTabGrid();
                }
            });
        });
    };
    self.AddSubprojectResourceTab = function (parentConfigurationItemId, configurationItemId, model) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/AddConfigurationItemSubprojectResource", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            parentConfigurationItemId: parentConfigurationItemId,
            configurationItemId: ko.unwrap(configurationItemId),
            subprojectResourceModel: ko.map.toJS(model)
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshSubprojectTabGrid();
        });
    };
    self.RefreshSubprojectTabGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemSubprojectCollection", JSON.stringify(ko.map.toJS({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            parentConfigurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            pageIndex: self.SubprojectTabPageIndex(),
            pageSize: self.SubprojectTabPageSize(),
            sorting: self.SubprojectTabSorting()
        })), function (searchResult) {
            self.SelectedSubprojectTabRow(null);
            self.SelectedSubprojectQualificationTabRow(null);
            self.SelectedSubprojectResourceTabRow(null);
            self.SubprojectTabTotalRows(0);
            self.SubprojectTabCollection([]);
            if (searchResult != null && searchResult.Model != null) {
                var rows = ko.map.fromJS(searchResult.Model.SubProjectModelsFiltered);
                self.SubprojectTabCollection(rows());
                self.SubprojectTabTotalRows(searchResult.Model.TotalRows);
                self.TargetHoursHtml(searchResult.Model.TargetHoursHtml);
                self.TargetSumHtml(searchResult.Model.TargetSumHtml);
                self.ToggleSubprojectTabToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.Save = function (model) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/SaveConfigurationItemSubproject", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            parentConfigurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.Refresh = function () {
        self.RefreshSubprojectTabGrid();
    };
    self.CompleteCheck = function () {
        return true;
    };
    self.loaded = function () {
        return self.Refresh();
        self.RefreshSubprojectTabGrid();
    };
}
;
export default ConfigurationItemSubprojectViewModel;